import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
//import store from "../../../Redux_Store";
//let server = "http://localhost:5001/possibilities-parenting/us-central1/serverResponse";
let server = "https://us-central1-possibilities-parenting.cloudfunctions.net/serverResponse";

if (!firebase.apps.length) {
  const config = {
    apiKey: "AIzaSyC7wfwLtOf3RhyelZOz9u8jiMzda5jeDGI",
    authDomain: "coaching-platform-illumine.firebaseapp.com",
    databaseURL: "https://coaching-platform-illumine.firebaseio.com",
    projectId: "coaching-platform-illumine",
    storageBucket: "coaching-platform-illumine.appspot.com",
    messagingSenderId: "1002955816731",
    appId: "1:1002955816731:web:7826d9a3f63fb75a499dbe",
    measurementId: "G-P02VM70XHT"
  };
  firebase.initializeApp(config);
}
let database = firebase.database();

export const subscribeAProduct = function (productId, _user, amount) {
  let user = firebase
    .auth()
    .currentUser;
  if (user) {
    let uid = user.uid;
    /**REVISED LOGIC INTEGRATIN THE PAYU PAYMENT */
    let txnid = database
      .ref()
      .child(`paymentHistories/`)
      .push()
      .key;
    //TODO this needs to be variablaized
    var paymentData = {
      key: "vXGyByvR",
      productinfo: productId,
      txnid,
      amount: amount,
      email: user.email,
      phone: `${_user.phoneNumber}`||"8369903919",
      lastname: _user.lastname || "",
      firstname: _user.firstName || "Not Set",
      surl: `https://awaken.illumine.in/application/paymentResponse/${txnid}`,
      furl: "https://awaken.illumine.in/application/library",
      udf1: uid
    };

    fetch(`${server}/pay`, {
      method: 'POST',
      body: JSON.stringify(paymentData)
    }).catch(err => {
      console.log(err)
    }).then(response => {
      if (!response) {
        console.log("Server is not working");
      } else {
        response
          .json()
          .then(response => {
            paymentData.hash = response;
            console.log(paymentData);
            window
              .bolt
              .launch(paymentData, {
                responseHandler: function (BOLT) {
                  if (BOLT.response.txnStatus === "SUCCESS") {
                    fetch(`${server}/paymentResponse`, {
                      method: 'POST',
                      body: JSON.stringify(BOLT.response)
                    }).catch(err => {
                      console.log(err)
                    }).then(response_ => {
                      console.log(response_)
                    });
                  }
                },
                catchException: function (BOLT) {
                  // alert(BOLT.message);
                  console.log(BOLT);
                }
              });
          });
      }
    });
  } else {
    console.log("user is not signed in. Redirect to home");
  }
}